<script>
    import { createEventDispatcher } from "svelte";
    import Icon from "$lib/UI/Icon.svelte";
    import { l } from "$lib/Utils/l10n.svelte";

    export let show = true;

    const dispatch = createEventDispatcher();

    function doClose() {
        show = false;
        dispatch("close");
    }
</script>

{#if show}
    <div class="header">
        <slot />

        <div class="buttons" on:click={doClose}>
            <Icon
                icon="circle-xmark"
                style="light"
                on:click={doClose}
                tooltip={l("Sluit")}
            />
        </div>
    </div>
{/if}

<style>
    .buttons {
        cursor: pointer;
    }

    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 5px;
        border: solid 1px gray;
        background: var(--message-strip-background);
        border-radius: 5px;
        margin: 0.1rem 0.5rem;
    }
</style>
